// store/rootReducer.js
import { combineReducers } from '@reduxjs/toolkit';
import sidebarslice from './slice/sidebarslice';
import bufferReducer from './slice/bufferSlice';
import currentStageReducer from './slice/currentStageSlice';
import authdataslice from './slice/authdataslice';
import permissionReducer from './slice/permissionSlice';

const appReducer = combineReducers({
  sidebarslice,
  buffer: bufferReducer,
  currentStage: currentStageReducer,
  authToken: authdataslice,
  permissions: permissionReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL_STATE') {
    state = undefined; // This resets everything including persisted state
  }
  return appReducer(state, action);
};

export default rootReducer;
